module.exports = __webpack_public_path__ + "static/media/marker.53fb47b0.svg";